import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { AuthProvider } from 'auth'
import App from './components/App'

import store from './store'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)
